import { useEffect, useState } from "react";
import { getTokensFromCurrencyPair } from "../helpers/getTokensFromCurrencyPair";

interface UseCurrencyDirectionProps {
  currencyPair: string;
  onCurrencyChange: (fromCurrency: string, toCurrency: string) => void;
}

export const useCurrencyDirection = ({
  currencyPair,
  onCurrencyChange,
}: UseCurrencyDirectionProps) => {
  const [fromToSequence, setFromToSequence] = useState<number[]>([0, 1]);
  const currencyPairArr = getTokensFromCurrencyPair(currencyPair);

  const handleSwitchCurrency = (fromCurrency?: string, toCurrency?: string) => {
    const newSequence = [...fromToSequence];
    newSequence.reverse();

    setFromToSequence(newSequence);

    onCurrencyChange(
      currencyPairArr[newSequence[0]],
      currencyPairArr[newSequence[1]]
    );
  };

  // reset sequence to default on currencyPair change
  useEffect(() => {
    const defaultSequence = [0, 1];
    setFromToSequence(defaultSequence);

    if (currencyPairArr.length >= 2) {
      onCurrencyChange(
        currencyPairArr[defaultSequence[0]],
        currencyPairArr[defaultSequence[1]]
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyPair]);

  return {
    fromCurrency: currencyPairArr[fromToSequence[0]] || "",
    toCurrency: currencyPairArr[fromToSequence[1]] || "",
    handleSwitchCurrency,
  };
};
